export default __webpack_public_path__ + "static/media/logoWhite.c8b665b1.svg";